import { DatabaseIcon, CameraIcon, FileTextIcon, CalendarIcon } from 'lucide-react'
import React from 'react'

export const BUTTONS_CONTAINER_DATA_ADMIN = [
  {
    icon: React.createElement(DatabaseIcon, { size: 16 }),
    onClick: () => alert('Database button clicked'),
    id: '22341',
  },
  { icon: React.createElement(CameraIcon, { size: 16 }), onClick: () => alert('Camera button clicked'), id: '22342' },
  {
    icon: React.createElement(FileTextIcon, { size: 16 }),
    onClick: () => alert('File Text button clicked'),
    id: '22343',
  },
  {
    icon: React.createElement(CalendarIcon, { size: 16 }),
    onClick: () => alert('Calendar button clicked'),
    id: '22344',
  },
]

export const EVENT_NOTIFICATION_MOCK = {
  eventTitle: 'Ostatnie zdarzenie',
  eventText: 'Przeciążenie o 37%',
  timestamp: '12:32 25.02.24',
  buttonText: 'Panel Alarmów',
  deviceNumber: 'SW-1200-08',
  handleXIcon: () => alert('Clicked the X icon button!'),
  handleButton: () => alert('Clicked the "Alarm Panel" button!'),
}

export const WEATHER_ALERT_MOCK = {
  title: 'Alert pogodowy!',
  description: 'W okolicy suwnicy XYZ przewiduje się gwałtowną zmianę warunków pogodowych.',
  handleXIcon: () => alert('Clicked the X icon button!'),
}

export const HELP_ALERT_MOCK = {
  firstParagraph: 'Potrzebujesz pomocy?',
  secondParagraph: 'Sprawdź naszą dokumentację.',
  buttonText: 'Documentation',
  handleButton: () => alert('Clicked the "Documentation" button!'),
  handleIconButton: () => alert('Clicked the icon button!'),
}

export const PROGRESS_BAR_MOCKS = [
  {
    label: 'MP1',
    progress: 75,
  },
  {
    label: 'MJW1',
    progress: 50,
  },
  {
    label: 'MJW1',
    progress: 19,
  },
  {
    label: 'MJW1',
    progress: 35,
  },
  {
    label: 'MJW1',
    progress: 75,
  },
  {
    label: 'Hover',
    progress: 50,
  },
  {
    label: 'End of life',
    progress: 0,
  },
]

export const COLORS = {
  primary: '#60a5fa',
  grid: '#71717a',
  'inactive-light': 'rgba(128,128,128,0.3)',
  'inactive-dark': 'rgba(64, 64, 64, 0.5)',
  alarm: 'rgba(255,59,59,0.18)',
  error: 'rgba(245,158,66,0.18)',
  lineBackground: 'rgba(56,189,248,0.10)',
  alarmHover: 'rgba(255,59,59,0.35)',
  errorHover: 'rgba(245,158,66,0.35)',
  'text-dark': '#09090b',
  'text-light': '#f9fafb',
  'background-dark': '#09090b',
  'background-light': '#e2e8f0',
}
